import { render, staticRenderFns } from "./GptConversationStarters.vue?vue&type=template&id=a9bc8010"
import script from "./GptConversationStarters.vue?vue&type=script&lang=ts"
export * from "./GptConversationStarters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports